import ActionTypes from './constants';

const DEFAULT_FILTER = { 
    divisionList: [],
    subdivisionList: [],
    selectedDivision: '', 
    selectedSubdivisions: []
};

export default (state = DEFAULT_FILTER, action) => {
    switch (action.type) {
        case ActionTypes.SET_DIVISION_LIST : {
            return Object.assign({}, state, {
                divisionList: [...action.divisionList]
            });
        }
        case ActionTypes.SET_SUBDIVISION_LIST : {
            return Object.assign({}, state, {
                subdivisionList: [...action.subdivisionList]
            });
        }
        case ActionTypes.SET_SELECTED_SUBDIVISIONS : {
            return Object.assign({}, state, {
                selectedSubdivisions: [...action.selectedSubdivisions]
            });
        }
        case ActionTypes.SET_SELECTED_DIVISION : {
            return Object.assign({}, state, {
                selectedDivision: action.selectedDivision
            });
        }
        default:
            return state;
    }
}